import { render } from "./ZoomImage.vue?vue&type=template&id=17763655&scoped=true"
import script from "./ZoomImage.vue?vue&type=script&lang=js"
export * from "./ZoomImage.vue?vue&type=script&lang=js"

import "./ZoomImage.vue?vue&type=style&index=0&id=17763655&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17763655"]])

export default __exports__